import React, {Component, PropTypes} from 'react';

const LivreCell = ({livreid,titre, titreorig,editeur_nom,editeur,collection}) => {
    
    
    let mytitre = titre;
    /*if (titreorig){
        mytitre = (<span> {titre} (Titre original : {titreorig})</span>);
    }*/
    let myediteur;
    if (editeur_nom){
        myediteur = (<div>
            <a href={'/i.php/listedition/' + editeur}>
                {editeur_nom}
            </a> 
            {collection && (
                <span>{" / " + collection} </span>
            )}
        </div>
        );
    }
    return (
        <div>
            {myediteur}
        </div>
    )
}

export default LivreCell


// WEBPACK FOOTER //
// ./shared/LivreCell.jsx